import { useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getLocaleFromPath, buildLocalePath, stripLocalePrefix } from "./localePath";

export function useLocaleSwitch(): (code: string) => void {
  const navigate = useNavigate();
  const { pathname, search, hash } = useLocation();
  const { i18n } = useTranslation();

  return useCallback(
    (code: string) => {
      void i18n.changeLanguage(code);
      localStorage.setItem("daynav.language", code);

      const currentLocale = getLocaleFromPath(pathname);
      if (currentLocale) {
        const bare = stripLocalePrefix(pathname);
        navigate(`${buildLocalePath(code, bare)}${search}${hash}`, { replace: true });
      }
    },
    [pathname, search, hash, navigate, i18n],
  );
}
